import styles from './BusinessElementStateCompleted.module.scss';
import likeIcon from './icons/like.png';

export const BusinessElementStateCompleted = () => {
    return (
        <div>
            <span className={styles.levelTitle}>Следующий уровень</span>

            <div className={styles.levelBlockSuccess}>
                <img alt='like' src={likeIcon} className={styles.icon} />
        
                <p className={styles.text}>
                    Поздравляем! <br/> Вы достигли максимального уровня
                </p>
            </div>
        </div>
    );
}